<template>
  <div class="statistics-container mt-1">
    <div class="box first" v-if="data">
      <div class="info"><span class="icon" @click="showInfo(1)"><i class="fas fa-info-circle"></i></span></div>
      <div class="info-box" v-show="showInfoSelected === 1" @mouseleave="showInfo(0)">
        <span>{{ CONSTANTS.getCopy('STATISTICS_INFO_NUMBER_INTENTS') }}</span>
      </div>
      <div class="content">
        <div>
          <span class="score">{{ `${data.totalIntents.intentsNew}/${data.totalIntents.intentsTotal}` }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_LEGEND_INTENTS') }}</span>
          <span class="percentage">{{ data.totalIntents.intentsPercent }}% <img class="triangle"
              :src="require(`@/assets/${getTriangleIconPath(data.totalIntents.intentsPercent)}`)" /></span>
        </div>
        <div class="v-line"></div>
        <div>
          <span class="score">{{ `${data.totalIntents.phrasesNew}/${data.totalIntents.phrasesTotal}` }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_LEGEND_NEW_PHRASES') }}</span>
          <span class="percentage">{{ data.totalIntents.phrasesPercent }}% <img class="triangle"
              :src="require(`@/assets/${getTriangleIconPath(data.totalIntents.phrasesPercent)}`)" /></span>
        </div>
      </div>
    </div>
    <div class="box second" v-if="data">
      <div class="info"><span class="icon" @click="showInfo(2)"><i class="fas fa-info-circle"></i></span></div>
      <div class="info-box" v-show="showInfoSelected === 2" @mouseleave="showInfo(0)">
        {{ CONSTANTS.getCopy('STATISTICS_INFO_MESSAGES_CONVERSATIONS_TRAFFIC') }}
      </div>
      <div class="content">
        <div>
          <span class="score">{{ data.conversations.messagesTotal }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_LEGEND_MESSAGES') }}</span>
          <span class="percentage">{{ data.conversations.messagesPercent }} % <img class="triangle"
              :src="require(`@/assets/${getTriangleIconPath(data.conversations.messagesPercent)}`)" /></span>
        </div>
        <div class="v-line"></div>
        <div>
          <span class="score">{{ data.conversations.conversationsTotal }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_LEGEND_CONVERSATIONS') }}</span>
          <span class="percentage">{{ data.conversations.conversationsPercent }} % <img class="triangle"
              :src="require(`@/assets/${getTriangleIconPath(data.conversations.conversationsPercent)}`)" /></span>
        </div>
      </div>
    </div>
    <div class="box third" v-if="data">
      <div class="info"><span class="icon" @click="showInfo(3)"><i class="fas fa-info-circle"></i></span></div>
      <div class="info-box" v-show="showInfoSelected === 3" @mouseleave="showInfo(0)">
        {{ CONSTANTS.getCopy('STATISTICS_INFO_SUCCESS_RATE') }}
        <span>{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_RATE_ERROR') }}</span>
        <span>{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_RATE_DOUBT') }}</span>
        <span>{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_RATE_RIGHT') }}</span>
        <span>{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_RATE_POSITIVE_FEEDBACK') }}</span>
      </div>
      <div class="content">
        <div class="error">
          <span>{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_LEGEND_ERROR_EMOJI') }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_LEGEND_ERROR') }}</span>
          <span class="score">{{ data.totalMessages.totalError }} <span class="score-percentage">({{
              data.totalMessages.totalErrorPercent
          }}%)</span></span>
          <span class="percentage">{{ data.totalMessages.totalErrorPercentMedia }} % <img class="triangle"
              :src="require(`@/assets/${getTriangleIconPath(data.totalMessages.totalErrorPercentMedia, 'black')}`)" /></span>
        </div>
        <div class="v-line"></div>
        <div class="doubt">
          <span>{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_LEGEND_DOUBT_EMOJI') }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_LEGEND_DOUBT') }}</span>
          <span class="score">{{ data.totalMessages.totalDuda }} <span class="score-percentage">({{
              data.totalMessages.totalDudaPercent
          }}%)</span></span>
          <span class="percentage">{{ data.totalMessages.totalDudaPercentMedia }} % <img class="triangle"
              :src="require(`@/assets/${getTriangleIconPath(data.totalMessages.totalDudaPercentMedia, 'black')}`)" /></span>
        </div>
        <div class="v-line"></div>
        <div class="good">
          <span>{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_LEGEND_RIGHT_EMOJI') }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_LEGEND_RIGHT') }}</span>
          <span class="score">{{ data.totalMessages.totalOK }} <span class="score-percentage">({{
              data.totalMessages.totalOKPercent
          }}%)</span></span>
          <span class="percentage">{{ data.totalMessages.totalOKPercentMedia }} % <img class="triangle"
              :src="require(`@/assets/${getTriangleIconPath(data.totalMessages.totalOKPercentMedia, 'black')}`)" /></span>
        </div>
        <div class="v-line"></div>
        <div class="ok">
          <span>{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_LEGEND_OK_EMOJI') }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_SUCCESS_LEGEND_OK') }}</span>
          <span class="score">{{ data.totalMessages.totalFeedback }} %</span>
          <span class="percentage">{{ data.totalMessages.totalFeedbackPercent }} % <img class="triangle"
              :src="require(`@/assets/${getTriangleIconPath(data.totalMessages.totalFeedbackPercent, 'black')}`)" />
          </span>
        </div>
      </div>
    </div>
    <div class="box fourth" v-if="data">
      <div class="info"><span class="icon" @click="showInfo(4)"><i class="fas fa-info-circle"></i></span></div>
      <div class="info-box" v-show="showInfoSelected === 4" @mouseleave="showInfo(0)">
        {{ CONSTANTS.getCopy('STATISTICS_INFO_RATE_MESSAGES_TRAINED') }}
      </div>
      <div class="content">
        <div>
          <span class="score">{{ `${data.trainning.totalTrainedPeriod}/${data.trainning.totalPeriod}`
          }}</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_INFO_MESSAGES_TRAINED_LEGEND') }}</span>
          <span class="percentage">{{ data.trainning.trainedPercent }} %</span>
        </div>
        <div class="v-line"></div>
        <div>
          <span class="score">{{ data.trainning.pendingPercent }}%</span>
          <span class="legend">{{ CONSTANTS.getCopy('STATISTICS_INFO_MESSAGES_TRAINED_LEGEND_FROM_TOTAL') }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: { data: Object },
  data () {
    return {
      showInfoSelected: 0,
      percentageNegativeRegExp: /^-{1}/
    }
  },
  methods: {
    showInfo (box) {
      this.showInfoSelected = box
    },
    getTriangleIconPath (percentage, color = 'white') {
      if (this.percentageNegativeRegExp.test(percentage)) {
        return color === 'white' ? 'decreasing-triangle-white.png' : 'decreasing-triangle-black.png'
      }
      return color === 'white' ? 'growing-triangle-white.png' : 'growing-triangle-black.png'
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Analytics/Statistics.vue